import {Injectable} from "@angular/core";
import {IQuestionEntry, IAnswer} from "../../api/data-model";

@Injectable()
export class AnswerPresentationService {

    public setupPresentationOrder(question: IQuestionEntry): void {
        if (this.shouldRandomize(question)) {
            this.randomize(question.answers);
        } else {
            if (this.shouldOrderAnswers(question)) {
                this.orderAnswers(question.answers);
            }
        }
    }

    randomize(answers: IAnswer[]): void {
       //  answers.forEach(answer => console.log(answer.text));
        // go from right to left in array
        for (let i: number = answers.length - 1; i > 0; i -= 1) {
            // pick a different element in the array
            let j = Math.floor(Math.random() * (i + 1));
            // remove the ith element
            let temp: IAnswer = answers[i];
            // swap the ith element with the random element you picked
            answers[i] = answers[j];
            answers[j] = temp;
        }
        // answers.forEach(answer => console.log(answer.text));

    }

    orderAnswers(answers: IAnswer[]): void {
        if (answers.length === 2 &&
            ((answers[0].text.toLowerCase() === "false" && answers[1].text.toLowerCase() === "true") ||
            (answers[0].text.toLowerCase() === "no" && answers[1].text.toLowerCase() === "yes"))) {
            let answertemp: IAnswer = answers[0];
            answers[0] = answers[1];
            answers[1] = answertemp;
        }
    }

    shouldRandomize(question: IQuestionEntry): boolean {
        if ((question.type === "MultipleChoice" || question.type === "MultipleChecks") &&
            ! this.isYesNoQuestionType(question)) {
            return true;
        } else {
            return false;
        }
    }

    shouldOrderAnswers(question: IQuestionEntry): boolean {
        return this.isYesNoQuestionType(question) || question.type === "TrueFalse";
    }

    isYesNoQuestionType(question: IQuestionEntry): boolean {
        let isMultiChoiceQuestion:boolean = question.type === "MultipleChoice";

        if (isMultiChoiceQuestion && question.answers.length === 2) {
            let answer1:boolean = question.answers[0].text.toLowerCase() === "yes" ||
                                  question.answers[0].text.toLowerCase() === "no";
            let answer2:boolean = question.answers[1].text.toLowerCase() === "yes"
                                  || question.answers[1].text.toLowerCase() === "no";
            return answer1 && answer2;
        }

        return false;
    }

}
